import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	documentTitle: {
		id: 'project-archived-direct-link.document-title',
		defaultMessage: 'Archived project',
		description: 'Document title for the Archived project page.',
	},
	header: {
		id: 'project-archived-direct-link.header',
		defaultMessage: 'This project has been archived',
		description: 'Page header for the Archived project page.',
	},
	description: {
		id: 'project-archived-direct-link.description',
		defaultMessage: 'If you want to edit an issue, ask your Jira admin to restore the project.',
		description: 'Page description for the Archived project page.',
	},
	viewProjects: {
		id: 'project-archived-direct-link.view-projects',
		defaultMessage: 'View all projects',
		description: 'View all projects button text',
	},
	descriptionIssueTerminologyRefreshM4: {
		id: 'project-archived-direct-link.description-issue-terminology-refresh-m4',
		defaultMessage: 'If you want to edit a work item, ask your Jira admin to restore the project.',
		description: 'Page description for the Archived project page.',
	},
});
